/**
 * Icon Service - Centralized icon URL management
 * 
 * All cryptocurrency icons are served from the API to ensure consistency
 * and avoid external dependencies.
 */

const API_BASE_URL = '/api/exchange';

/**
 * Get the icon URL for a cryptocurrency
 * @param {string} currencyId - The CoinGecko currency ID
 * @returns {string} The API icon URL
 */
export const getIconUrl = (currencyId) => {
  if (!currencyId) return null;
  return `${API_BASE_URL}/icons/${currencyId.toLowerCase()}`;
};

/**
 * Check if an icon URL is the internal API
 * @param {string} url - The icon URL
 * @returns {boolean}
 */
export const isInternalIcon = (url) => {
  if (!url) return false;
  return url.startsWith('/api/icons/');
};

/**
 * Convert external icon URL to internal if possible
 * @param {string} currencyId - The CoinGecko currency ID
 * @param {string} externalUrl - The external icon URL
 * @returns {string} The internal or external icon URL
 */
export const normalizeIconUrl = (currencyId, externalUrl) => {
  if (!currencyId) return externalUrl;
  return getIconUrl(currencyId);
};
